import { Component, OnInit, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.css']
})
export class HeroComponent implements OnInit, AfterViewInit {
  particleOptions = '{"particles": {"number": {"value": 15,"density": {"enable": true,"value_area": 2000}},"color": {"value": ["#000000", "#000000", "#000000", "#000000", "#000000"]},"shape": {"type": "circle","stroke":{"width":0,"color":"#000000"}},"opacity": {"value": 0.3,"random": false,"anim": {"enable": false,"speed": 1,"sync": false}},"size": {"value": 8,"random": true,"anim": {"enable": false,"sync": true}},"line_linked":{"enable":false,"distance":0,"color":"#ffffff","opacity":0.4,"width":1},"move": {"enable": true,"speed":1,"direction": "right","random": false,"straight": false}},"interactivity": {"detect_on": "canvas","events": {"onhover": {"enable": false,"mode": "repulse"},"onclick": {"enable": false,"mode": "push"},"resize": true}},"retina_detect": false}';

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    // Initialize atropos if needed
    this.initAtropos();
  }

  initAtropos(): void {
    // Atropos initialization
    if (typeof (window as any).Atropos !== 'undefined') {
      const atroposElements = document.querySelectorAll('[data-atropos]');
      atroposElements.forEach((element: Element) => {
        new (window as any).Atropos({
          el: element
        });
      });
    }
  }
}
